'use strict';

function completion_form_load() {
  if ($('.form-offer-completion').length != 0) {
    formValidateConfig($('.form-offer-completion'));

    var offerID = $('.offer-form').find('.jc-offer-header').attr("data-id");
    var cityElement = $('.city');
    var cpfCnpjElement = $('.cpfcnpj');
    var cepElement = $('.cep');
    var phoneElement = $('.phone');
    var formOffer = $("#form-offer-" + offerID);

    validatorCep();
    maskCep(cepElement);

    validatorCpfCnpj();
    maskCpfCnpj(cpfCnpjElement);

    validatorPhone();
    maskPhone(phoneElement);

    validatorCpfCnpj();
    validatorCep();

    loadCityByCep(cepElement, cityElement);
    loadDealershipByCity(cityElement);

    validatorBirthdate();

    $('[name=offer-submit]').off();

    formOffer.find('[name=offer-submit]').on('click', function (event) {
      event.preventDefault();
      if ($('.form-offer-completion').valid()) {
        catalogCompletionForm(offerID);
      }
    });

    $('#edit-lead-data').on('click', function (event) {
      event.preventDefault();
      $('#user-data-show').collapse();
      $('.user-data-edit').collapse("show");
    });

    $('.city').on('change', function () {
      $('.jc-offer-form-scroll-list .radio:not([data-city="' + $(this).val() + '"])').css('display', 'none');
      $('.jc-offer-form-scroll-list .radio:not([data-city="' + $(this).val() + '"])').prop('checked', false);
      $('.jc-offer-form-scroll-list [data-city="' + $(this).val() + '"]').css('display', 'block');
      if ($('.jc-offer-form-scroll-list [data-city="' + $(this).val() + '"]').length === 1) {
        $('.jc-offer-form-scroll-list [data-city="' + $(this).val() + '"] input').prop('checked', true);
      }
      $('.dealerships').css('display', 'block');
    });

    $('.jc-offer-form-scroll-list .radio:not([data-city="' + $('.city').val() + '"])').css('display', 'none');
    $('.jc-offer-form-scroll-list [data-city="' + $('.city').val() + '"]').css('display', 'block');
    if ($('.jc-offer-form-scroll-list [data-city="' + $('.city').val() + '"]').length == 1) {
      $('.jc-offer-form-scroll-list [data-city="' + $('.city').val() + '"] input').prop("checked", true);
    }
    $('[name=lgpd]').prop("checked", true);
    $('.dealerships').css('display', 'block');
  }
}

function catalogCompletionForm(offerID) {

  validatorConfig();

  var form = $('#form-offer-' + offerID);
  var phoneElement = form.find('.phone');

  var latitude = null;
  var longitude = null;

  getLocationUser().then(function (coordinates) {
    latitude = coordinates['latitude'];
    longitude = coordinates['longitude'];
  });

  formValidateConfig(form);
  maskPhone(phoneElement);
  validatorEmail();
  validatorPhone();

  var tempName = form.find('.name').val().trim(),
      fullName = tempName.replace(/( )+/g, ' '),
      name = fullName.split(' ')[0],
      surname = fullName.indexOf(' ') !== -1 ? fullName.substr(fullName.indexOf(' ') + 1) : '',
      email = form.find('.email').val(),
      phone = form.find('.phone').val(),
      oferta = offerID,
      cpfcnpj = form.find('.cpfcnpj').val(),
      cep = form.find('.cep').val(),
      dealership = form.find('.dealerships input:checked').val(),
      message = form.find('.message').val(),
      button = form.find('button[type="submit"]'),
      optIns = {},
      lgpd = [];

  form.find(".jc-opt-in").each(function () {
    optIns[$(this).attr('name')] = $(this).prop('checked');

    if ($(this).prop('checked')) {
      lgpd.push([$(this).attr('name'), $(this).parents(".form-group").text().trim(), $(this).parents(".form-group").find('a') ? $(this).parents(".form-group").find('a').map(function () {
        return $(this).attr('href');
      }).get() : null]);
    }
  });

  var buttonLabel = button.text();
  button.prop('disabled', true).html('<i class="fa fa-cog fa-spin fa-fw"></i> Enviando...');

  grecaptcha.ready(function () {
    grecaptcha.execute(ajaxHandler.siteKey, { action: 'save_lead' }).then(function (grecaptchaToken) {

      $.ajax({
        url: ajaxHandler.url,
        type: 'POST',
        data: {
          action: 'jc_ajax_offer_save_lead_email_form',
          context: 'catalogo-0km',
          name: name,
          surname: surname,
          email: email,
          phone: phone,
          cpfcnpj: cpfcnpj,
          cep: cep,
          oferta: oferta,
          dealership: dealership,
          message: message,
          url_page: window.location.href,
          lgpd: encodeURIComponent(JSON.stringify(lgpd)),
          optIns: encodeURIComponent(JSON.stringify(optIns)),
          getParameters: encodeURIComponent(JSON.stringify(getUrlVars())),
          latitude: latitude,
          longitude: longitude,
          token: grecaptchaToken
        },
        success: function success(response) {
          if (response && response.success) {
            var leadID = response.data.leadID;
            setLeadIdSessionStorage(leadID);
            send_offer_lead_success_events(offerID, leadID, 'Oferta');
            gtm_get_data_and_send_lead_saved(leadID, 'landingPage').then(function () {
              loadThankYouPage(leadID, offerID, $('#offer-form-modal .offer-form'));
            });
          } else {
            send_offer_lead_error_events();
            populateAndShowFormError(form, response.data);
            button.prop('disabled', false).html(buttonLabel);
          }
        },
        error: function error(data) {
          showFormError(form);
          button.prop('disabled', false).html(buttonLabel);
        }
      });
    });
  });
}

var loadThankYouPage = function loadThankYouPage(leadID, offerID, offerForm) {
  $.ajax({
    url: ajaxHandler.url,
    type: 'POST',
    data: {
      // action: 'jc_ajax_ad_thank_you_page_content',
      action: 'jc_ajax_modal_thank_you_page_content',
      offerID: offerID,
      leadID: leadID
    },
    success: function success(response) {
      if (response && response.success) {
        offerForm.trigger('thankYouPageLoaded');
        offerForm.html(response.data.template);
      }
    }
  });
};